export default __webpack_public_path__ + "static/media/448.343878d4.jpg";